import {
	isEmpty,
	groupWords,
	alphabetizeTiles,
	isTilesInBlacklist,
	getDictionaryByValue,
	sortObjectKeys,
} from "@/common/functions";

export default {
	currentLanguage: (state) => state.currentLanguage,
	isLanguage: (state) => (lang) => state.currentLanguage === lang,
	loading: (state) => state.status.loading,
	error: (state) => state.status.error,
	secondQuery: (state) => state.status.secondQuery,
	burgerActive: (state) => state.navigation.burgerActive,
	getCurrentPage: (state) => state.navigation.current,
	getWords: (state) => groupWords(state.results.words),
	getRawWords: (state) => state.results.words,
	getTiles: (state) => state.query.tiles,
	getUnsortedTiles: (state) => {
		if (state.query.unsortedTiles.length) return state.query.unsortedTiles;
		return state.query.tiles;
	},
	getStartsWith: (state) => state.query.startsWith,
	getEndsWith: (state) => state.query.endsWith,
	getContains: (state) => state.query.contains,
	getAdvancedSearchOptions: (state, getters) => {
		let o = {};
		if (getters.getStartsWith.length) o.starts = getters.getStartsWith;
		if (getters.getEndsWith.length) o.ends = getters.getEndsWith;
		if (getters.getContains.length) o.contains = getters.getContains;
		if (getters.getWordlength !== null)
			o.word_length = parseInt(getters.getWordlength);
		return o;
	},
	getAnagram: (state) =>
		alphabetizeTiles(state.query.tiles, state.navigation.current),
	getExact: (state) => state.query.exact,
	getExactMatch: (state) => state.results.match,
	getWordlength: (state) => state.query.wordlength,
	nonWildcardTiles: (state, getters) =>
		getters.getUnsortedTiles.replace(/_/g, ""),
	countNonWildcardTiles: (state, getters) => getters.nonWildcardTiles.length,
	countWildcards: (state) => state.query.tiles.split("_").length - 1,
	getExperimentChannel: (state) => {
		// If this is a test or a prerendering script running it, always return A.
		if (
			typeof window.__TEST__ !== "undefined" ||
			typeof window.__PRERENDER_INJECTED !== "undefined"
		) {
			return "A";
		}

		if (state.experiments.overrideChannel) {
			return state.experiments.overrideChannel;
		}
		return state.experiments.channel;
	},
	getExperimentDate: (state) => state.experiments.date,
	lastVisited: (state) => state.lastVisited,
	getSafeTiles: (state, getters) => {
		if (isTilesInBlacklist(state.query.tiles)) return getters.getAnagram;
		return getters.getTiles;
	},
	getFinderHeight: (state) => state.finderHeight,
	getSavedWords: (state) => state.savedWords,
	getSavedWordsList: (state) =>
		state.savedWords.map((el) => {
			return el.word;
		}),
	wordGroupKeys: (state) =>
		Object.keys(state.words)
			.filter((k) => state.words[k])
			.sort((a, b) => b - a),
	combinedWordGroupKeys: (state) => {
		const sortedWords = sortObjectKeys(state.words);
		const sortedWordsWithWildcards = sortObjectKeys(
			state.wordsWithWildcards
		);
		return [...sortedWords, ...sortedWordsWithWildcards];
	},
	getCurrentDictionary: (state) => {
		const stateDictionary = getDictionaryByValue(state.query.dictionary);
		return isEmpty(stateDictionary) ? {} : stateDictionary;
	},
	getBonusPoints: (state) =>
		state.query.bonuspoints === null ? false : state.query.bonuspoints,
	getDefinitionButtons: (state) => (id) => {
		return (
			!isEmpty(state.definitionButtons) &&
			!isEmpty(state.definitionButtons[id]) &&
			state.definitionButtons[id] === true
		);
	},
	combinedWords: (state) => {
		return { ...state.words, ...state.wordsWithWildcards };
	},
	getSpecialGameType: (state) => {
		return state.query.specialGameType;
	},
	isLoadingSavedWords: (state) => {
		return state.loadingSavedWords;
	},
};
